import { Redirect, Route, Switch } from 'react-router-dom'
import React from 'react'
import PropTypes from 'prop-types'
import createUrl from '../../modules/create-url'
import isServerSide from '../../modules/is-server-side'

let isInitial = true
const getInitialData = ({ data }) => {
  if (isServerSide()) return data

  if (isInitial) {
    isInitial = false
    return data
  }
  return null
}

const Router = ({ initialData, customRoutes, Topics, ...props }) => (
  <Switch location={props.location}>
    <Redirect from="/index.html" to="/" />
    {Object.keys(customRoutes).map((routeName, index) => {
      const route = customRoutes[routeName]
      return (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          render={({ location, match, ...routeProps }) =>
            React.createElement(Topics(route.topic), {
              ...routeProps,
              location: location,
              match: match,
              view: routeName,
              api: route.api ? route.api : location && !route.apiUrl && location.pathname,
              apiUrl: createUrl(route.apiUrl),
              initialData: getInitialData({ data: initialData }),
              ...props,
            })
          }
        />
      )
    })}
  </Switch>
)

Router.propTypes = {
  initialData: PropTypes.object,
  customRoutes: PropTypes.object,
}

export default Router
